import React, { useEffect, useState } from "react";
import "../styles/Holiday.css";
import HolidayUserDetails from "./holiday_user_details.js";

const HolidayInfo = (props) => {
  const [showDetails, setShowDetails] = useState(false);
  const [user, setUser] = useState([]);
  const [years, setYears] = useState([]);

  useEffect(() => {}, []);

  const total_days = (date_1, date_2) => {
    let difference = date_1.getTime() - date_2.getTime();
    let TotalDays = Math.ceil(difference / (1000 * 3600 * 24)) + 1;
    return TotalDays;
  };

  const checkFreeDay = (date) => {
    var bool = false;
    props.freeDaysData.map((el) => {
      if (
        date.getFullYear() +
          "-" +
          (date.getMonth() + 1 > 9
            ? date.getMonth() + 1
            : "0" + (date.getMonth() + 1)) +
          "-" +
          (date.getDate() > 9 ? date.getDate() : "0" + date.getDate()) ===
        el.date
      ) {
        bool = true;
      }
    });
    return bool;
  };

  const countDays = (holiday) => {
    var count = 0;
    for (
      var i = new Date(holiday.date_from);
      i <= new Date(holiday.date_to);
      i.setDate(i.getDate() + 1)
    ) {
      if (
        !(i.getDay() === 6) &&
        !(i.getDay() === 0) &&
        !checkFreeDay(i) &&
        +i.getFullYear() === new Date().getFullYear()
      ) {
        count++;
      }
    }
    return count;
  };

  const countDaysUsed = (holiday) => {
    var count = 0;
    for (
      var i = new Date(holiday.date_from);
      i <= new Date(holiday.date_to);
      i.setDate(i.getDate() + 1)
    ) {
      if (
        !(i.getDay() === 6 || i.getDay() === 0 || checkFreeDay(i)) &&
        +i.getFullYear() === new Date().getFullYear()
      ) {
        if (i < new Date()) {
          count++;
        }
      }
    }
    return count;
  };

  const showDetailsOn = (e) => {
    setUser(e.target.value);
    setShowDetails(true);
  };

  const showDetailsOff = (e) => {
    setUser("");
    setShowDetails(false);
  };

  const getReportedDays = (name) => {
    var holidays = props.holidaysData.filter(
      (el) =>
        el.user === name && el.status === "REPORTED" && el.type === "holiday"
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getAcceptedDays = (name) => {
    var holidays = props.holidaysData.filter(
      (el) =>
        el.user === name && el.status === "ACCEPTED" && el.type === "holiday"
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getUsedDays = (name) => {
    var holidays = props.holidaysData.filter(
      (el) =>
        el.user === name && el.status === "ACCEPTED" && el.type === "holiday"
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDaysUsed(el);
    });
    return days;
  };

  const getSickDays = (name) => {
    var holidays = props.holidaysData.filter(
      (el) => el.user === name && el.status === "ACCEPTED" && el.type === "sick"
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getRemoteDays = (name) => {
    var holidays = props.holidaysData.filter(
      (el) =>
        el.user === name && el.status === "ACCEPTED" && el.type === "remote"
    );
    var days = 0;
    holidays.map((el) => {
      days = days + countDays(el);
    });
    return days;
  };

  const getDays = (name) => {
    var arr = props.users.filter((el) => el.name === name)[0];
    var data = props.yearHolidaysData.filter(
      (el) => el.name === arr.name && +el.year === new Date().getFullYear()
    )[0];
    return data === undefined ? 0 : data.days;
  };

  return (
    <>
      <div className="mainContainerHolidayPopUp">
        {showDetails ? (
          <HolidayUserDetails
            name={user}
            users={props.users}
            holidaysData={props.holidaysData}
            close={showDetailsOff}
            freeDaysData={props.freeDaysData}
            yearHolidaysData={props.yearHolidaysData}
            user={props.user}
          />
        ) : (
          <>
            <div className="closeBox">
              <button className="closeClientButton" onClick={props.close}>
                X
              </button>
            </div>
            <div id="holidayBox" className="titleBox">
              <span id="holidayTitle" className="filterTitle">
                Informacja o urlopach
              </span>
            </div>
            <div className="holidayInfoBox">
              {props.users.map((el) => (
                <>
                  <div className="holidayUserBox">
                    <p id="info_title">
                      {el.name} - rok {new Date().getFullYear()}
                    </p>
                    <div className="subHolidayBox">
                      <p className="main_h_info_label">
                        <span id="label_h">Ilość dni urlopu: </span>
                        <span id="boldPartH">{getDays(el.name)}</span>
                      </p>
                      <p className="main_h_info_label">
                        <span id="label_h">
                          Ilość dni urlopu wnioskowanego:{" "}
                        </span>
                        <span id="boldPartH">{getReportedDays(el.name)}</span>
                      </p>
                      <p className="main_h_info_label">
                        <span id="label_h">
                          Ilość dni urlopu zaakceptowanego:{" "}
                        </span>
                        <span id="boldPartH">
                          {getAcceptedDays(el.name) - getUsedDays(el.name) < 0
                            ? 0
                            : getAcceptedDays(el.name) - getUsedDays(el.name)}
                        </span>
                      </p>
                      <p className="main_h_info_label">
                        <span id="label_h">
                          Ilość dni urlopu wykorzystanego:{" "}
                        </span>
                        <span id="boldPartH">{getUsedDays(el.name)}</span>
                      </p>
                      <p className="main_h_info_label">
                        <span id="label_h">Pozostałe dni urlopu: </span>
                        <span id="boldPartH">
                          {getDays(el.name) -
                            (getUsedDays(el.name) +
                              (getAcceptedDays(el.name) - getUsedDays(el.name) <
                              0
                                ? 0
                                : getAcceptedDays(el.name) -
                                  getUsedDays(el.name))) -
                            getReportedDays(el.name)}
                        </span>
                      </p>
                      <br />
                      <p className="main_h_info_label">
                        <span id="label_h">
                          Ilość dni zwolnienia chorobowego:{" "}
                        </span>
                        <span id="boldPartH">{getSickDays(el.name)}</span>
                      </p>
                      {el.urlopyZdalna === 1 ? (
                        <p className="main_h_info_label">
                          <span id="label_h">Ilość dni pracy zdalnej: </span>
                          <span id="boldPartH">{getRemoteDays(el.name)}</span>
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                    <button
                      className="paymentMenuButton"
                      value={el.name}
                      onClick={showDetailsOn}
                    >
                      SZCZEGÓŁY
                    </button>
                  </div>
                </>
              ))}
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default HolidayInfo;
